export default __webpack_public_path__ + "5c6552c4798ff069a80933e250ecc1b6.png";